import {Assessment} from '@/api/Coach/useGetCoachInfo';
import {useGetAssessment} from '@/api/CoachAndDirector/useGetAssessment';
import {
  AssessmentPlayerPerformanceData,
  useGetSelectedPlayersAssessmentData,
} from '@/api/CoachAndDirector/useGetSelectedPlayersAssessmentData';
import {useGetDirectorInfo} from '@/api/Director/useGetDirectorInfo';
import {PlayerSessionSummary} from '@/api/Trainer/useGetPlayerLastSessionSummary';
import {useProfiles} from '@/api/User/useProfiles';
import {roleType} from '@/constants/constants';
import {PlayerAssessmentDataView} from '@/pages/Coach/CoachPlayerAssessmentData/PlayerAssessmentData.view';
import {convertDateRange, downloadPerformanceDataAsExcel} from '@/pages/Coach/utils';
import {Team} from '@/user/user.interface';
import {getUserDisplayName} from '@/utils/utils';
import {useMemo} from 'react';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';

export const DirectorPlayerAssessmentData = () => {
  const {teamId} = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {currentProfile} = useProfiles();
  const {data: directorInfo} = useGetDirectorInfo(currentProfile?._id);
  const [playerId, assessmentId] = [searchParams.get('playerId') ?? '', searchParams.get('assessmentId') ?? ''];
  const {data: assessmentInfo} = useGetAssessment(assessmentId, roleType.director);
  const {data: playersAssessmentData, isLoading} = useGetSelectedPlayersAssessmentData({
    playerIds: playerId,
    assessmentId,
    role: roleType.director,
    sortBy: '',
  });
  const teamInfo = useMemo(
    () => directorInfo?.teams.find((team) => team._id === teamId),
    [teamId, directorInfo?.teams]
  );

  const playerInfo = playersAssessmentData?.[0]?.playerInfo;
  const playerName = getUserDisplayName(playerInfo?.firstName, playerInfo?.lastName);
  const date = convertDateRange(assessmentInfo?.startDate ?? '', assessmentInfo?.endDate ?? '');
  const playerAssessmentData = playersAssessmentData?.[0]?.performanceDetails;

  const isSessionSelectionCompleted = useMemo(
    () =>
      playerAssessmentData?.exerciseSummary?.find((exercise) => {
        return 'confirmedBy' in exercise;
      }),
    [playerAssessmentData]
  );

  const onClickDownloadHandler = async () => {
    downloadPerformanceDataAsExcel(
      playersAssessmentData as AssessmentPlayerPerformanceData[],
      assessmentInfo as Assessment,
      teamInfo as Team
    );
  };

  return (
    <PlayerAssessmentDataView
      isLoading={isLoading}
      playerAssessmentData={playerAssessmentData as PlayerSessionSummary}
      isSessionSelectionCompleted={!!isSessionSelectionCompleted}
      date={date}
      playerName={playerName}
      onClickDownloadHandler={onClickDownloadHandler}
      assessmentName={assessmentInfo?.name || ''}
      onClickGoBack={() => navigate(-1)}
    />
  );
};
